import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptAnnouncement } from "../adapters/adaptAnnouncements";

const fetchAnnouncement = async (id: number): Promise<IAnnouncement> => {
	const response = await cmsClient.get<IAnnouncement>(`/announcements/${id}/`);
	return response.data;
};

const useAnnouncement = (id: number) => {
	const query = useQuery(["announcement", id], () => fetchAnnouncement(id), {
		enabled: id > 0,
		select: adaptAnnouncement
	});
	return query;
};

export default useAnnouncement;
